// src/pages/MS/MSN001F1.jsx 사용자 정보

import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import {postData} from "utils/TransactionUtil";
import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";
import style from "./MSU101F1.module.scss";
import Icon from "../../components/Icon/Icon";
import DataGrid from "../../components/DataGrid/DataGrid";



const MSN001F1 = ({handle_Close, comHandleClick_Save}) => {


/* 조회기능 ====================================================================================================*/
    const [schUser, setSchUser] = useState("");
    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        //{ key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptCd',  name: '기관ID',  width: '0%' },
        { key: 'hsptNm',  name: '기관명',  width: '200px' },
        { key: 'userId',  name: '아이디',  width: '200px' },
        { key: 'userNm',  name: '이름',  width: '300px' }

    ];

    const btnClick_schUser = (e) => {
        getUserSearch();
    }

    const [resHspt, setResHspt] = useState("");
    const [resUserId, setResUserId] = useState("");
    const [resUserNm, setResUserNm] = useState("");
    const [resRoleId, setResRoleId] = useState("");


    // 데이터 클릭
    const handleClick_DataGrid_row = (e) => {
        setResHspt(e.row.hsptCd);
        setResUserId(e.row.userId);
        setResUserNm(e.row.userNm);
        setResRoleId(e.row.roleId);
    }

    const handleDoubleClick_DataGrid_row = (e) => {
        if(resUserId===''|| resUserId===undefined || resUserId===null) return;
        handle_Close(e.row.userId, e.row.userNm,e.row.hsptCd,e.row.roleId);
    }


    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            if(resUserId===''|| resUserId===undefined || resUserId===null){
                toast({ type: 'info', message: '선택된 데이터가 없습니다.'});
                return;
            }
            handle_Close(resUserId, resUserNm, resHspt, resRoleId);
        });
    }, [comHandleClick_Save]);


    /* Call Service====================================================================================================*/

    async function getUserSearch() {
        const param = {schUser:schUser};
        let result = await postData("/MSU/getUserSearch", param);
        setRows_subjectList(result);
        // toast({ type: 'info', message: '적용이 완료되었습니다.'});
        // handle_Close();

    }



    return(
        <main>
            <div className={style.search_wrap}>
                <div style={{display: "flex", gap:"10px"}}>
                    <input
                        type="text"
                        className={style.schUserNm}
                        // defaultValue={schUserNm}
                        onChange={(e) => setSchUser(e.target.value)}
                        name="schUserNm"
                        maxLength={'12'}
                        placeholder="사용자명 또는 ID 검색"
                        // onKeyDown={(e) => handleKeyDown_schUserNm(e)}

                    />
                    <Button variant="Secondary" size="md" addStyle={{width: "100px", height: "38px"}}
                            onClick={() => btnClick_schUser()}>조회 </Button>
                </div>
        </div>
            <div className={styleCom.main_wrap} >


                <div className={styleCom.title_wrap} style={{marginTop: "10px", color:"gray"}}>
                    * 리스트에서 사용자를 선택(더블클릭) 하시거나 확인버튼을 눌러주십시오.
                </div>
                <div style={{marginTop: "10px", height:"450px"}}>
                    <DataGrid
                        cols={cols_subjectList}
                        rows={rows_subjectList}
                        rowHeight={37}
                        onCellClick={(e) => handleClick_DataGrid_row(e)}
                        onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>

            </div>
        </main>
    )
}
export default MSN001F1;